import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ProductInventoryItemUtilsService } from '@app/modules/service-data/services/product-inventory-item-utils.service';
import { ProductInventoryItemState } from '@app/modules/service-data/store/product-inventory-item.state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionsLocation,
  DataTableActionType,
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-product-inventory-item-failed-warning',
  imports: [DataTableComponent, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './product-inventory-item-failed-warning.component.html',
})
export class ProductInventoryItemFailedWarningComponent implements OnInit {
  private store = inject(Store);
  protected modalRef = inject(NgbActiveModal);
  private productInventoryItemUtilsService = inject(
    ProductInventoryItemUtilsService
  );
  private translateService = inject(TranslateService);

  productInventoryItemIds: string[];

  protected dataTableConfiguration: DataTableConfiguration;

  ngOnInit() {
    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      columns: [
        {
          label: 'pii.details.failedWarning.columns.product',
          property: 'product.internalName',
        },
        {
          label: 'pii.details.failedWarning.columns.status',
          property: 'lastStatus',
        },
      ],
      actionsLocation: DataTableActionsLocation.RIGHT,
      singleActions: [
        {
          name: 'pii.details.failedWarning.actions.openDetails',
          icon: 'fa-light fa-file',
          type: DataTableActionType.BUTTON,
          action: (event, pii) => {
            this.productInventoryItemUtilsService.openDetails(pii.id);
          },
        },
      ],
      doubleClickAction: (event, pii) => {
        this.productInventoryItemUtilsService.openDetails(pii.id);
      },
      rows$: this.store
        .select(ProductInventoryItemState.getProductInventoryItemsByIds)
        .pipe(
          map((getByIds) => getByIds(this.productInventoryItemIds)),
          switchMap((piis) =>
            this.productInventoryItemUtilsService.getExtendedProductInventoryItemList(
              piis,
              { product: true }
            )
          )
        ),
    };
  }
}
